<script setup>
import { ref, defineProps, defineEmits } from 'vue'

// MAPメニュー用コンポーネント
import AccordionBodyMap from './AccordionBodyMap.vue';
// 圃場メニュー用コンポーネント
import AccordionBodyField from './AccordionBodyField.vue';
// 開発ツール用コンポーネント
import AccordionBodyDevTools from './AccordionBodyDevTools.vue';

const props = defineProps(['mapInfo', 'fields'])
const mapInfo = ref(props.mapInfo)

const emit = defineEmits(['selectField', 'showModal', 'onChangeMapInfo'])

// リスト選択イベント
function moveMapCenter(LatLng) {
  emit('selectField', LatLng);
}

// モーダル表示イベント
function showModal(field) {
  emit('showModal', field);
}

// マップ情報変更イベント
function onChangeMapInfo() {
  emit('onChangeMapInfo', mapInfo);
}
</script>

<template>
  <div class="offcanvas-header bg-dark text-light p-2" style="display: flex; justify-content: center; align-items: center; position: relative;">
    <h5 class="offcanvas-title" style="position: absolute; left: 50%; transform: translateX(-50%);">Menu</h5>
    <button type="button" class="btn-close text-reset btn-close-white" style="margin-left: auto;" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body p-0">
    <div class="accordion accordion-flush" id="accordionMenu">
      <!-- MAP -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button p-2 text-bg-secondary" type="button" data-bs-toggle="collapse" data-bs-target="#menuMap" aria-expanded="true" aria-controls="menuMap">
            <i class="bi bi-map me-1"></i>MAP
          </button>
        </h2>
        <div id="menuMap" class="accordion-collapse collapse show">
          <div class="accordion-body p-1">
            <AccordionBodyMap v-bind:mapInfo="mapInfo" v-bind:fields="props.fields" @onChangeMapInfo="onChangeMapInfo"></AccordionBodyMap>
          </div>
        </div>
      </div>
      <!-- 圃場 -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button p-2 text-bg-secondary collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#menuField" aria-expanded="true" aria-controls="menuField">
            <i class="bi bi-border-all me-1"></i>圃場
          </button>
        </h2>
        <div id="menuField" class="accordion-collapse collapse">
          <div class="accordion-body p-1">
            <AccordionBodyField v-bind:fields="props.fields" @selectField="moveMapCenter" @showModal="showModal"></AccordionBodyField>
          </div>
        </div>
      </div>
      <!-- Dev Tools -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button p-2 text-bg-secondary collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#menuDevTools" aria-expanded="true" aria-controls="menuDevTools">
            <i class="bi bi-incognito me-1"></i>Dev Tools
          </button>
        </h2>
        <div id="menuDevTools" class="accordion-collapse collapse">
          <div class="accordion-body p-1">
            <AccordionBodyDevTools @selectField="moveMapCenter"></AccordionBodyDevTools>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>
